import { createMuiTheme } from '@material-ui/core/styles';
import Kobenhavn from '../static/fonts/Kobenhavn.ttf';

const kobenhavn = {
  fontFamily: 'Kobenhavn',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `local('Kobenhavn'),
    url(${Kobenhavn}) format('embedded-opentype'), /* Internet Explorer */
    url(${Kobenhavn}) format('woff2'), /* Super Modern Browsers */
    url(${Kobenhavn}) format('woff'), /* Pretty Modern Browsers */
    url(${Kobenhavn}) format('truetype'), /* Safari, Android, iOS */
    url(${Kobenhavn}) format('svg'); /* Legacy iOS */`,
};

export const primaryColor = (alpha = '1') => {
  return `rgba(40, 71, 92,${alpha})`; // cadet
};
export const secondaryColor = (alpha = '1') => {
  return `rgba(91, 110, 125,${alpha})`;
};
export const greenColor = 'rgba(0,166,75,1)';
const buttonPrimaryColor = () => {
  return greenColor; // green
};
const buttonHoverColor = () => {
  return 'rgba(70, 181, 113, 1)';
};
const buttonPressedColor = () => {
  return 'rgba(0, 100, 58, 1)';
};
export const buttonInactiveColor = () => {
  return 'rgba(180, 184, 194, 1)';
};

export const warningColor = 'rgb(237,106,50)';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: primaryColor(),
      light: primaryColor('0.1'),
      dark: primaryColor('0.8'),
    },
    secondary: {
      main: secondaryColor(),
      light: secondaryColor('0.1'),
      dark: secondaryColor('0.9'),
    },
    error: {
      main: warningColor,
    },
    background: {
      default: '#fff',
    },
  },
  spacing: (factor) => `${0.5 * factor}rem`,
  typography: {
    fontFamily: ['Calibri', 'Arial', 'sans-serif'].join(','),
    fontSize: 14,
    body2: {
      fontSize: '0.9rem',
    },
    body1: {
      fontSize: '0.9rem',
    },
    h2: {
      fontSize: '1.7rem',
      fontFamily: [kobenhavn.fontFamily, 'Arial', 'sans-serif'].join(','),
    },
    h3: {
      fontSize: '1.3rem',
      fontFamily: [kobenhavn.fontFamily, 'Arial', 'sans-serif'].join(','),
    },
    h4: {
      fontSize: '1.1rem',
      fontFamily: [kobenhavn.fontFamily, 'Arial', 'sans-serif'].join(','),
    },
    h6: {
      fontFamily: [kobenhavn.fontFamily, 'Arial', 'sans-serif'].join(','),
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [kobenhavn],
      },
    },
    MuiPaper: {
      root: {
        padding: '2rem 1rem',
        backgroundColor: '#fff',
        color: primaryColor(),
      },
    },
    MuiButton: {
      contained: {
        '&$disabled': {
          backgroundColor: buttonInactiveColor(),
          color: '#fff',
        },
        '&:hover': {
          backgroundColor: buttonHoverColor(),
        },
      },
      containedPrimary: {
        label: {
          color: '#fff',
          '&$disabled': {
            backgroundColor: '#fff',
            color: '#fff',
          },
        },
        backgroundColor: buttonPrimaryColor(),
        '&:hover': {
          backgroundColor: buttonHoverColor(),
        },
      },
      outlinedPrimary: {
        borderColor: greenColor,
        border: '2px solid',
        fontWeight: 'bold',
        '&:hover': {
          borderColor: greenColor,
          border: '2px solid',
        },
      },
      textPrimary: {
        color: primaryColor(),
      },
      textSecondary: {
        color: secondaryColor(),
      },
    },
    MuiTextField: {
      root: {
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused fieldset': {
            borderColor: buttonPrimaryColor(),
          },
        },
      },
    },
    MuiInputLabel: {
      root: {
        '&$focused': {
          color: buttonPrimaryColor(),
        },
      },
      outlined: {
        '&$shrink': {
          color: buttonPrimaryColor(),
        },
      },
    },
    MuiLink: {
      root: {
        fontWeight: 'bold',
      },
    },
    MuiSnackbar: {
      root: {
        backgroundColor: '#fff',
        color: primaryColor(),
        border: '2px solid',
        borderColor: primaryColor(),
        borderRadius: '5px',
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#fff',
        color: primaryColor(),
      },
    },
  },
});
export { theme };
